<template>
  <v-expansion-panels v-if="policies.length" flat>
    <v-expansion-panel>
      <v-expansion-panel-header hide-actions>
        <template v-slot:default="{ open }">
          <span v-t="label" />
          <v-spacer />
          <v-icon small v-text="getIcon(open)" />
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content eager>
        <ul>
          <li
            v-for="(policy, i) in policies"
            :key="i"
            v-text="translateByPolicy(policy)"
          />
        </ul>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "Components.PasswordPolicies.Label"
    },
    policies: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getIcon(isOpen) {
      return isOpen ? "mdi-minus-box-outline" : "mdi-plus-box-outline";
    },
    translateByPolicy({ type, value }) {
      if (typeof type !== "string") return "";
      if (type === "REGEX_PATTERN") {
        return this.$t(`Security.PasswordValidation.RegexPattern`, {
          "0": value
        });
      }
      if (type === "SPECIAL_CHARS") {
        return this.$t(`Security.PasswordValidation.SpecialChars`, {
          "0": value
        });
      }
      if (type === "NOTUSERNAME") {
        return this.$t("Security.PasswordValidation.NotUserName");
      }
      if (type === "NOTRECENTLYUSED") {
        return this.$t("Security.PasswordValidation.NOTRECENTLYUSED", {
          "0": value
        });
      }
      const key = `${type.charAt(0).toUpperCase()}${type
        .slice(1)
        .toLowerCase()}`;
      return this.$t(`Security.PasswordValidation.${key}`, { "0": value });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../_variables.scss";

::v-deep {
  .v-expansion-panels .v-expansion-panel {
    color: $font-color;
  }

  .v-expansion-panel-header {
    height: 44px; // hüpfen des Aktivators auschalten
    border-bottom: 1px solid $card-title-border-color;
    padding: $expansion-panel-header-padding;
    font-size: 1.15rem;
  }

  .v-expansion-panel-content__wrap {
    padding: $expansion-panel-content-padding;
  }

  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 48px;
  }

  .v-expansion-panel-header > :not(.v-expansion-panel-header__icon) {
    flex: 0 1 auto;
  }

  .v-icon {
    border-radius: 4px;
    padding: 4px 0px;
    background-color: $expansion-panel-icon-background-color;
    color: $expansion-panel-icon-color;

    &:hover {
      background-color: $expansion-panel-icon-hover-background-color;
    }
  }
}

//ie11 bugfix
::v-deep :not(.v-expansion-panel-header--mousedown) {
  &.v-expansion-panel-header {
    &::before {
      opacity: 0;
    }
  }
}
</style>
